<template>
  <div class="modal new-team-member animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="$emit('close')">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">Invite Team Member</p>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="float-label">
            <input type="email" name="email" id="email" v-model="invite.email" required>
            <label for="email">Email Address</label>
          </div>
          <a @click="includePersonalMessage = true" v-if="!includePersonalMessage">Include a personal message?</a>
          <div class="float-label personal-message" v-if="includePersonalMessage">
            <textarea name="message" placeholder="Message" rows="6" cols="60"></textarea>
            <label>Optional Message</label>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary is-large" @click="sendInvite()">Send Invitation</a>
      </footer>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';

export default {
  mixins: [API],
  data() {
    return {
      includePersonalMessage: false,
      invite: {
        email: ''
      }
    }
  },
  methods: {
    sendInvite() {
      this.api().sendTeamInvite(this.spark.state.currentTeam.id, this.invite)
        .then(result => {
          (new Notyf()).confirm('Invitation sent!');
          this.$emit('close');
        }, function() {
          (new Notyf()).alert('Invitation failed to send');
        });
    }
  }
}

</script>

<style lang="scss" scoped>
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
</style>



// WEBPACK FOOTER //
// new-team-member-modal.vue?3af08a83